import { render, staticRenderFns } from "./ChangeTextBlock.vue?vue&type=template&id=7f6b5e20"
import script from "./ChangeTextBlock.vue?vue&type=script&lang=js"
export * from "./ChangeTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports